export var getSupport = function (state) { return state.support; };
export var getSupportFormStatus = function (state) { return state.support.formStatus; };
export var getTitlesFromState = function (state) { return state.support.titles; };
export var getMessages = function (state) { return state.support.messageData; };
export var getIsLoading = function (state) { return state.support.isLoading; };
